<template>
  <div>
    <el-form ref="formMyTask" :model="formInline" label-width="120px" :size="defaultFormItemSize" label-position="right"
             @submit.native.prevent>
      <filter-box :item-width="350" operatorPosition='start'>
        <el-form-item label="流水号">
          <el-input class="filter-item" v-model="formInline.serialNo" placeholder="流水号"></el-input>
        </el-form-item>
        <el-form-item label="流程名称">
          <el-select v-model="formInline.tableName" placeholder="请选择" clearable>
            <el-option-group
              v-for="group in options"
              :key="group.processDefinitionKey"
              :label="group.processDefinitionName">
              <el-option
                v-for="item in group.children"
                :key="item.processDefinitionKey"
                :label="item.processDefinitionName"
                :value="item.processDefinitionKey">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="工程名称/文号">
          <el-input class="filter-item" v-model="formInline.runName" placeholder="工程名称/文号"></el-input>
        </el-form-item>
        <el-form-item label="范围">
          <el-select v-model="formInline.doType" placeholder="请选择">
            <el-option
              v-for="item in doTypeList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发起时间" prop="createDate">
          <date-range class="filter-item"
            v-model="formInline.createDate"
            :clearable="true" :allowTypes="['day']" align="left"
            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <el-form-item label="工程名称" prop="formInline.gcmc">
          <el-select style="width:100%" filterable :clearable="true" v-model="formInline.gcmc" placeholder="工程名称">
            <el-option
              v-for="item in projectList"
              :key="item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同名称" prop="formInline.htmc">
          <el-select style="width:100%" filterable  :clearable="true" v-model="formInline.htmc" placeholder="合同名称">
            <el-option
              v-for="item in contractList"
              :key="item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <div style="margin-left:30px">
          <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="onSubmit">查询</el-button>
          <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onReset">重置</el-button>
        </div>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="flowEntry" :data="dataList" :size="defaultFormItemSize" header-cell-class-name="table-header-gray">
          <el-table-column label="流水号" prop="serialNo" width="130px"  />
          <el-table-column label="流程名称" prop="processDefinitionName" width="200px"  />
          <el-table-column label="文号" prop="runName">
            <template slot-scope="scope">
               <span >{{scope.row.runName || (scope.row.masterData && scope.row.masterData.run_name) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发起时间" prop="createTime"  width="200px"/>
          <el-table-column label="状态" prop="flowStatusName" width="200px">
            <template slot-scope="scope">
              <span :style="{'color':color[scope.row.flowStatusName]}">{{scope.row.flowStatusName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180px">
            <template slot-scope="scope">
              <el-button class="table-btn primary" :size="defaultFormItemSize" type="text" @click="handleBind(scope.row)">
                详情
              </el-button>
              <el-button class="table-btn primary" :size="defaultFormItemSize" type="text" @click="handleRemind(scope.row)" v-if="showBtn==2&&scope.row.flowStatus !== 3&&scope.row.flowStatus !== 5">
                催办
              </el-button>
              <!-- <el-button class="table-btn primary" :size="defaultFormItemSize" type="text" @click="handleCancel(scope.row)" v-if="showBtn==2&&scope.row.flowStatus !== 3&&scope.row.flowStatus !== 5">
                撤销
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="total"
            :current-page="formInline.pageParams.pageNum"
            :page-size="formInline.pageParams.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="onCurrentPageChange"
            @size-change="onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {uploadMixin, statsDateRangeMixin, cachePageMixin} from '@/core/mixins';
import {mapGetters} from 'vuex';
import {FlowEntryController, FlowOperationController} from '@/api/flowController';
import {SysFlowWorkOrderStatus} from "@/staticDict/flowStaticDict";
import { OnlineOperation } from '@/api/onlineController.js';

export default {
  name: 'workSearch',
  data() {
    return {
      options: [],
      formInline: {
        runName: '',
        tableName: '',
        doType: '1',
        pageParams: {
          pageNum: 1,
          pageSize: 10
        },
        gcmc: '',
        htmc: ''
      },
      dataList: [],
      total: 0,
      doTypeList: [
        {
          name: '由我经办',
          value: '1'
        },
        {
          name: '由我发起',
          value: '2'
        },
        {
          name: '所有',
          value: '3'
        }
      ],
      showBtn: '',
      color:{ '处理中' : 'rgb(0, 128, 0)','审批中' : 'rgb(0, 128, 0)','已拒绝' : 'rgb(0, 128, 0)','已办结' : 'rgb(255, 0, 0)','已结束' : 'rgb(255, 0, 0)', '已撤销' : '#999','暂存':'#000'}, //任务状态color
      projectList:[],
      contractList:[]
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  computed: {
    defaultFormItemSize() {
      return 'mini';
    },
    ...mapGetters(['getUserInfo'])
  },
  created() {
    this.getSelect()
    this.getData()
    this.init()
  },
  watch:{
    $route:{
      immediate:true,
      deep: true,
      handler(val){
        if(val.name === 'workSearch'){
          const row = JSON.parse(localStorage.getItem('work'))
          if (row) {
            this.handleBind(row)
          }
        }
      }
    }
  },
  methods: {
    init(){
      OnlineOperation.listDict(this, {
        dictId: '1637650160030846976'
      }).then(res=>{
        this.projectList = res.data
      })
      OnlineOperation.listDict(this, {
        dictId: '1684463201976061952'
      }).then(res=>{
        this.contractList = res.data
      })
    },
    getSelect() {
      FlowEntryController.getTreeList(this, {}).then(res => {
        let list = []
        for (let key in res.data) {
          let obj = {
            processDefinitionName: key,
            processDefinitionKey: res.data[key].processDefinitionKey,
            children: res.data[key]
          }
          list.push(obj)
        }
        this.options = list
      })
    },
    getData() {
      let params = {
        flowWorkOrderDtoFilter: {
          doType: this.formInline.doType,
          runName: this.formInline.runName || undefined,
          serialNo:this.formInline.serialNo || undefined,
          createTimeStart: this.formInline.createDate ? this.formInline.createDate[0] : undefined,
          createTimeEnd: this.formInline.createDate ? this.formInline.createDate[1] : undefined,
          gcmc: this.formInline.gcmc ? this.formInline.gcmc : undefined,
          htmc: this.formInline.htmc ? this.formInline.htmc : undefined
        },
        pageParam: this.formInline.pageParams
      }
      this.showBtn = this.formInline.doType
      FlowOperationController.listWorkOrder(this, params, {
        processDefinitionKey: this.formInline.tableName == '' ? 'all' : this.formInline.tableName
      }).then(res => {
        if (res.data.dataList.length > 0) {
          res.data.dataList.forEach(item => {
            item.flowStatusName = SysFlowWorkOrderStatus.getValue(item.flowStatus)
          })
        }
        this.dataList = res.data.dataList
        this.total = res.data.totalCount
      })
    },
    onSubmit() {
      this.formInline.pageParams.pageNum = 1
      this.getData()

    },
    onReset() {
      this.formInline = {
        doType: '1',
        runName: '',
        tableName: '',
        serialNo: '',
        createDate:[],
        pageParams: {
          pageNum: 1,
          pageSize: 10
        }
      }
      this.getData()
    },
    handleBind(row) {
      localStorage.setItem('work',JSON.stringify(row))
      let params = {
        processInstanceId: row.processInstanceId
      }
      FlowOperationController.viewInitialHistoricTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            // 在线流程参数配置
            query: {
              serialNo:row.serialNo,
              isRuntime: false,
              processDefinitionKey: row.processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: true,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator,
              flag: false,
              flowStatus: row.flowStatusName,
              form: 'work'
            }
          });
        }
      }).catch(e => {
      });
    },
    onCurrentPageChange(val) {
      this.formInline.pageParams.pageNum = val
      this.getData()
    },
    onPageSizeChange(val) {
      this.formInline.pageParams.pageSize = val
      this.getData()
    },
    /**
     *@desc 催办
     *@author Matthew
     *@date 2023/03/29 13:28:35
     */
    handleRemind(item) {
      FlowOperationController.remindRuntimeTask(this, {
        workOrderId: item.workOrderId
      }).then(res => {
        if (res.success) {
          this.$message.success('催办成功');
        }
      }).catch(e => {
      });
    },
    /**
     *@desc 撤销
     *@author Matthew
     *@date 2023/03/29 13:29:04
     */
    // handleCancel(item) {
    //   this.$confirm('是否撤销此工单？').then(res => {
    //     let params = {
    //       workOrderId: item.workOrderId,
    //       cancelReason: '主动撤销'
    //     }
    //     FlowOperationController.cancelWorkOrder(this, params).then(res => {
    //       if (res.success) {
    //         this.$message.success('撤销成功！');
    //         this.getData()
    //       }
    //     }).catch(e => {
    //     });
    //   }).catch(e => {
    //   });
    // }
  }

}
</script>
